var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-wrapper"},[_c('div',{staticClass:"footer"},[_c('span',[_vm._v("Delivered by")]),_vm._v(" \n      "),_c('a',{staticClass:"footer-link",attrs:{"target":"_blank","rel":"noopener","href":`https://${this.domain}/`}},[_vm._v("VCV")]),_vm._v(" \n      "),_c('span',[_vm._v("with 💚")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }